import * as angular from 'angular';

angular.module('app').filter('asDownload', asDownload);

function asDownload(uriUtility) {
	return function (uri) {
		return uri && uriUtility.fromPattern(uri, { download: 'true' });
	};
}
